import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import DataModule from "@/store/modules/DataModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import AiModule from "@/store/modules/AiModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    DataModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    AiModule,
  },
});

export default store;
